module.exports = __webpack_public_path__ + "img/orgLogoB.4f8211fc.jpg";